// extracted by mini-css-extract-plugin
module.exports = {"buttons":"buttons-module--buttons--2k4e7"};